export default __webpack_public_path__ + "static/media/message-template-1.544f1aad.png";